import { useCallback, useMemo } from 'react'
import useUserStore from '@/user/userStore'
import { useCreateUser } from '@/user/userQueries'
import { MobileFormValues } from './rules/mobileSchema'
import { extractCountryCodeAndMobile } from '@/user/mobile/MobileUtils'

interface UseMobileLogicResult {
    data: MobileFormValues | undefined
    loading: boolean
    saving: boolean
    isSuccess: boolean
    createUserData?: any
    onSubmit: (data: MobileFormValues) => void
}

export function useMobileLogic(): UseMobileLogicResult {
    const { user, setUser } = useUserStore()
    const createUser = useCreateUser()

    const data = useMemo(() => {
        if (!user?.mobile) return undefined

        const { countryCode, mobile } = extractCountryCodeAndMobile(user.mobile)
        return { countryCode, mobile, dateOfBirth: user.dateOfBirth || '' }
    }, [user?.mobile, user?.dateOfBirth])

    const onSubmit = useCallback(
        (formData: MobileFormValues) => {
            const mobile = `${formData.countryCode}${formData.mobile}`

            createUser.mutate({
                mobile,
                dateOfBirth: formData.dateOfBirth,
            })

            if (user) {
                setUser({
                    ...user,
                    mobile,
                    dateOfBirth: formData.dateOfBirth,
                })
            }
        },
        [createUser, user, setUser],
    )

    return {
        data,
        loading: false,
        saving: createUser.isPending,
        isSuccess: createUser.isSuccess,
        createUserData: createUser.data,
        onSubmit,
    }
}
